import { render } from "./List.vue?vue&type=template&id=54328592&ts=true"
import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/Irrigations/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54328592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54328592', __exports__)) {
    console.log('reload')
    api.reload('54328592', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=54328592&ts=true", () => {
    console.log('re-render')
    api.rerender('54328592', render)
  })

}


export default __exports__